import { render, staticRenderFns } from "./passwordRecover.vue?vue&type=template&id=9a863942&"
import script from "./passwordRecover.vue.ts?vue&type=script&lang=ts&"
export * from "./passwordRecover.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports